export default (path, options = {}) => {
  let updateResponse = null;
  let done = null;
  let then = null;
  let fail = null;
  let always = null;

  const defaultOptions = { method: 'GET' };
  const fetchOptions = Object.assign({}, defaultOptions, options);

  fetch(path, fetchOptions)
    .then(response => {
      return response.json();
    })
    .then(response => {
      if (updateResponse) {
        updateResponse(response);
      }
      if (done) {
        done(response);
      }
      if (then) {
        then(response);
      }
    })
    .catch((err) => {
      if (fail) {
        fail(err);
      }
    })
    .finally(() => {
      if (always) {
        always();
      }
    });

  return {
    updateResponse: function (updateResponseFn) {
      updateResponse = updateResponseFn;
      return this;
    },
    done: function (doneFn) {
      done = doneFn;
      return this;
    },
    then: function (thenFn) {
      console.warn('Используйте done вместо then', thenFn)
      then = thenFn;
      return this;
    },
    fail: function (failFn) {
      fail = failFn;
      return this;
    },
    always: function (alwaysFn) {
      always = alwaysFn;
      return this;
    }
  };
};
